<template>
    <div>   
        <BreadCrumb :data="breadCrumb" /> 
        <b-card header-tag="header" footer-tag="footer">  
        

            <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                                  
            <div class="auths" v-else>
                <b-form-group class="inputGrp">
                    <treeselect
                        :multiple="true"
                        :options="list"
                        :placeholder="$t('user.menus.allAuths')"
                        :noOptionsText="$t('user.menus.noOptionsText3')"
                        v-model="allAuths"
                        :show-count="false"
                        :normalizer="normalizer"
                        :default-expand-level="1"
                        :always-open="true"
                        :maxHeight=350
                        :flat="true"
                        :disable-branch-nodes="false"
                    >
                        <label slot="option-label" slot-scope="{ node, shouldShowCount, count }">
                            {{ node.label }}
                            <span v-if="shouldShowCount">({{ count }})</span>
                        </label>
                    </treeselect>
                    
                
                </b-form-group>
            
                <div class="buttons">
                    <b-button :title="$t('user.menus.transferAll')" size="sm" variant="outline-primary"  @click="addAllAuth"> <b-icon icon="chevron-double-right"> </b-icon>  </b-button> 
                    <b-button :title="$t('user.menus.transferSelecteds')" size="sm" variant="outline-primary" @click="addAuth"> <b-icon icon="chevron-right" ></b-icon>  </b-button>
                    <b-button :title="$t('user.menus.removeSelecteds')" size="sm" variant="outline-primary" @click="removeAuth"> <b-icon icon="chevron-left"></b-icon> </b-button> 
                    <b-button :title="$t('user.menus.removeAll')" size="sm" variant="outline-primary" @click="removeAllAuth"> <b-icon icon="chevron-double-left"> </b-icon>  </b-button> 
                </div>

                <b-form-group class="inputGrp" >
                    <treeselect
                        :multiple="true"
                        :options="auths"
                        :placeholder="$t('user.menus.currentAuths')"
                        :noOptionsText="$t('user.menus.noOptionsText4')"
                        v-model="selectedAuths"
                        :show-count="false"
                        :normalizer="normalizer"
                        :default-expand-level="1"
                        :always-open="true"
                        :maxHeight=350
                        :flat="true"
                        :disable-branch-nodes="false"
                    >
                        <label slot="option-label" slot-scope="{ node, shouldShowCount, count }">
                            {{ node.label }}
                            <span v-if="shouldShowCount">({{ count }})</span>
                        </label>
                    </treeselect>
                </b-form-group>
            </div>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" :onComplete="complete" />
    
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Table from "@/components/Table"
    import Modals from "./modals/";
    import Treeselect from '@riophae/vue-treeselect'
    import i18n from '@/plugins/i18n'
    import _ from 'lodash'
    let breadCrumb = [
        { label: i18n.t('pages.user.auths'), url: "/User/Auth" },
    ]

    export default {
        name: 'AuthList',
         created: async function(){
            await this.$store.dispatch('listAuthCasbin')
            await this.$store.dispatch('listAuthsCasbin', this.$route.params.id)

            this.breadCrumb.push({ label: this.$route.params.id, url: "/User/Auth" })
        },
        watch:{
            allAuths(data){
                let children = []
                let tmp = [...data]
                data.map(d => {
                    let parentAuth = this.list.find(l => l.ID === d)
                    if(parentAuth){
                        children = parentAuth.Children.map(c => c.ID)
                        !tmp.includes(...children) && tmp.push(...children)
                    }
                })
                data = _.union(data,tmp)
                if(JSON.stringify(data) !== JSON.stringify(this.allAuths))
                    this.allAuths = data
            },
            selectedAuths(data){
                let children = []
                let tmp = [...data]
                data.map(d => {
                    let parentAuth = this.auths.find(l => l.ID === d)
                    if(parentAuth){
                        children = parentAuth.Children.map(c => c.ID)
                        !tmp.includes(...children) && tmp.push(...children)
                    }
                })
                data = _.union(data,tmp)
                if(JSON.stringify(data) !== JSON.stringify(this.selectedAuths))
                    this.selectedAuths = data
            }
            
        },
        computed:{
          
            loading(){
                return this.$store.getters.getUserLoading
            },
            list(){
                const list = this.$store.getters.getAuthCasbin.filter(el => {
                    return el.Children.every(child => {
                        return this.allIDs(this.auths).every(id => {
                            return child.ID != id
                        })
                    })
                })
                return list.map(el => {
                    return { ID: el.Children ? (list.indexOf(el) + 10000) : list.indexOf(el), Description: el.Group,...el }
                })
            },
            auths(){
                const auths = this.$store.getters.getAuthsCasbin
                return auths.map(el => {
                    return { ID: el.Children ? (auths.indexOf(el) + 10000) : auths.indexOf(el), Description: el.Group,...el }
                })
            },
        },
        data: function(){
            return{
                breadCrumb, modalOpen: false,
                modalProps: {}, currentForm:"AuthCasbin", modalName: "",
                allAuths: [], selectedAuths: []
            }
        },
        components:{
            BreadCrumb, Table, Modals, Treeselect
        },
        methods:{
            normalizer(node) {
                return { id: node.ID, label: node.Description, children: node.Children }
            },
            allIDs(array) {
                return array.map(elem => elem.Children.map(child => `${child.ID}`)).flat()
            },
            getSelectedAuths(ids, array) {
                const selecteds = []
                ids.forEach(id => {
                    array.forEach(el => {
                        el.Children.forEach(child => {
                            if(child.ID != id) return
                            selecteds.push(child)
                        })
                    })
                })
                return selecteds.map(selected => {
                    return {
                        method: selected.Method,
                        path: selected.Path
                    }
                })
            },
            addAllAuth: async function(){
                const casbin_infos = this.getSelectedAuths(this.allIDs(this.list), this.list)
                await this.$store.dispatch('addAuthCasbin', {auth:this.$route.params.id, data: {casbin_infos}})
                this.$store.getters.getUserStatus.status == "Success" && this.complete()
            },
            addAuth: async function(){
                const casbin_infos = this.getSelectedAuths(this.allAuths, this.list)
                await this.$store.dispatch('addAuthCasbin', {auth:this.$route.params.id, data: {casbin_infos}})
                this.$store.getters.getUserStatus.status == "Success" && this.complete()
            },
            removeAllAuth: async function() {
                const casbin_infos = this.getSelectedAuths(this.allIDs(this.auths), this.auths)
                await this.$store.dispatch('removeAuthCasbin', {auth:this.$route.params.id, data: {casbin_infos}})
                this.$store.getters.getUserStatus.status == "Success" && this.complete()
            },
            removeAuth: async function() {
                const casbin_infos = this.getSelectedAuths(this.selectedAuths, this.auths)
                await this.$store.dispatch('removeAuthCasbin', {auth:this.$route.params.id, data: {casbin_infos}})
                this.$store.getters.getUserStatus.status == "Success" && this.complete()
            },
            async complete(){
                this.allAuths = []
                this.selectedAuths = []
                await this.$store.dispatch('listAuthCasbin')
                await this.$store.dispatch('listAuthsCasbin', this.$route.params.id)
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        }
    }
</script>
<style lang="css" scoped > 
    @import "./styles/casbin.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Users/AuthCasbin.vue